import React from 'react'
import { withRef } from '@udecode/cn'
import { PlateElement, useElement } from '@udecode/plate-common/react'
import { Box } from '@ui'

import { mentionInput } from '../../RichTextEditor.css'

import { TSlashCommandElement } from './autocomplete/types'

export const SlashCommandElement = withRef<typeof PlateElement>(({ children, ...props }, ref) => {
    const element = useElement<TSlashCommandElement>()

    return (
        <Box
            as="span"
            display="inline-block"
            data-slate-value={element.value}
            contentEditable={false}
            {...props.attributes}
            ref={props.attributes.ref ?? ref}
        >
            <Box as="span" display="inline-block" className={mentionInput}>
                {element.value}
            </Box>
            {children}
        </Box>
    )
})
